import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState({ new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) {
      setError("As palavras-passe não coincidem.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pw.new_password });
      setDone(true);
      setTimeout(() => navigate("/entrar"), 2500);
    } catch (err) {
      setError(err?.response?.data?.detail || "Ligação inválida ou expirada.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-5" data-testid="reset-page">
      <div className="w-full max-w-md bg-white border border-slate-200 shadow-sm p-8 sm:p-10">
        <h1 className="font-display text-2xl text-[#0072C6] mb-6">Definir nova palavra-passe</h1>
        {done ? (
          <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 px-4 py-3" data-testid="reset-success">
            Palavra-passe atualizada. A redirecionar para o login…
          </p>
        ) : (
          <form onSubmit={submit}>
            <label htmlFor="rp-new" className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2">Nova palavra-passe</label>
            <input id="rp-new" data-testid="reset-new" type="password" required minLength={8} value={pw.new_password}
              onChange={(e) => setPw((p) => ({ ...p, new_password: e.target.value }))}
              className="w-full border border-slate-200 px-4 py-3 text-sm mb-5 focus:outline-none focus:border-[#0072C6]" />
            <label htmlFor="rp-confirm" className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2">Confirmar</label>
            <input id="rp-confirm" data-testid="reset-confirm" type="password" required minLength={8} value={pw.confirm}
              onChange={(e) => setPw((p) => ({ ...p, confirm: e.target.value }))}
              className="w-full border border-slate-200 px-4 py-3 text-sm mb-6 focus:outline-none focus:border-[#0072C6]" />
            {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3" data-testid="reset-error">{error}</div>}
            <button type="submit" data-testid="reset-submit" disabled={loading || !token}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0072C6] text-white font-semibold py-4 text-sm hover:bg-[#005FA3] disabled:opacity-60">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Guardar
            </button>
          </form>
        )}
        <p className="text-center mt-6"><Link to="/entrar" className="text-sm text-slate-500 hover:text-[#0072C6]">← Voltar ao login</Link></p>
      </div>
    </div>
  );
}
